import {useState} from 'react';
import errorImageAsset from '../assets/errorImageLoading.svg';
import ErrorImage from '../assets/errorImageLoading.svg?react';
import SVG from 'react-inlinesvg';

export function SVGWrapper({image, alt, display, mode, width, height, backgroundColor, margin, padding, borderRadius, transition = true, loadDelay, onLoad}) {
    const [isLoadingImage, setIsLoadingImage] = useState(true);
    const [usingErrorImage, setUsingErrorImage] = useState(false);

    const handleLoad = () => {
        setTimeout(() => {
            setIsLoadingImage(false);
            if (onLoad) onLoad(true, image);
        }, loadDelay * 1000);
    };

    const handleError = () => {
        setTimeout(() => {
            setIsLoadingImage(false);
            setUsingErrorImage(true);
            if (onLoad) onLoad(false, image);
        }, loadDelay * 1000);
    };

    const getNoImage = () => {
        return errorImageAsset;
    };

    const getSize = () => {
        return {width: width, height: height};
    };

    const containerStyle = () => {
        const size = getSize();
        return {
            display: display || 'block',
            margin: margin || 'unset',
            padding: 'unset',
            width: size.width || 30,
            height: size.height || 30
        };
    };

    const svgContainerStyle = () => {
        const size = getSize();
        return {
            width: size.width || 30,
            height: size.height || 30,
            transform: `scale(${isLoadingImage ? 0 : 1})`,
            borderRadius: borderRadius || 0,
            transition: transition ? 'transform 0.2s ease' : 'unset',
            padding: padding ? padding : 0,
            background: backgroundColor || 'unset',
            display: 'block',
            boxSizing: 'border-box',
            margin: '0 auto'
        };
    };

    const svgStyle = () => {
        const size = getSize();
        return {
            width: size.width || 30,
            height: size.height || 30,
            objectFit: mode || 'cover'
        };
    };

    return (
        <div style={containerStyle()}>
            {usingErrorImage ? (
                <div className="flex items-center justify-center w-full h-full">
                    <ErrorImage alt="Error loading image" data-original-url={getNoImage()}/>
                </div>
            ) : (
                <div style={svgContainerStyle()}>
                    <SVG src={image} alt={alt} style={svgStyle()} draggable={false} onLoad={handleLoad} onError={handleError}/>
                </div>
            )}
        </div>
    );
}